import React, { FC } from 'react';
import Flatpickr, { DateTimePickerProps } from 'react-flatpickr';
import { makeStyles } from '@material-ui/core/styles';

const WIDTH = 250;
const BUTTON_WIDTH = 32;

const useStyles = makeStyles(theme => ({
  root: {
    isolate: true,
    '@global': {
      '.flatpickr-input': {
        display: 'none',
      },
      '.flatpickr-calendar': {
        width: WIDTH,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(12),
        borderRadius: 0,
        boxShadow: 'none',
      },
      '.flatpickr-months': {
        '& .flatpickr-prev-month, & .flatpickr-next-month': {
          fill: theme.custom.palette.grey2,

          '&:hover svg': {
            fill: theme.custom.palette.black2,
          },
        },
      },
      '.flatpickr-days': {
        width: WIDTH,

        '& .dayContainer': {
          width: WIDTH,
          minWidth: WIDTH,
          maxWidth: WIDTH,
        },
      },
      '.flatpickr-day': {
        maxWidth: BUTTON_WIDTH,
        height: BUTTON_WIDTH,
        lineHeight: `${BUTTON_WIDTH}px`,

        '&.today': {
          background: theme.custom.palette.grey4,
          borderColor: 'transparent',

          '&:hover, &:focus': {
            background: theme.custom.palette.grey3,
            borderColor: 'transparent',
            color: 'inherit',
          },
        },

        '&.selected, &.startRange, &.endRange': {
          background: theme.palette.secondary.main,
          borderColor: theme.palette.secondary.main,

          '& .prevMonthDay, &. nextMonthDay': {
            background: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main,
          },

          '&:hover, &:focus': {
            background: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
          },
        },
      },
    },
  },
}));

const FlatpickrWrapper: FC<DateTimePickerProps> = (props: DateTimePickerProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Flatpickr {...props} />
    </div>
  );
};

export default FlatpickrWrapper;
